export default "__VITE_ASSET__BCGCXg0J__"